import React from 'react'
import { Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

interface LoadingProps {}

export const Loading: React.FC<LoadingProps> = () => {
  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justifyContent='center'
    >
      <Grid item xs={3}>
        <CircularProgress />
      </Grid>
    </Grid>
  )
}
